export const sinceIntervals = [
    "MINUTES",
    "HOURS",
    "DAYS"
];
export const startsWithIntervalSince = (str)=>{
    return sinceIntervals.some((interval)=>str.startsWith(`${interval.toLowerCase()}Since_`));
};
